
import { Component, PropSync, Vue, Watch } from 'nuxt-property-decorator'

@Component
export default class OfferModal extends Vue {
  @PropSync('show', { required: true, default: false, type: Boolean })
  isShow!: boolean

  @Watch('isShow')
  onStateChange (bool: boolean) {
    if (bool) {
      document.body.classList.add('modal-open')
    } else {
      document.body.classList.remove('modal-open')
    }
  }
}
